import React from 'react';
import { Menu } from 'evergreen-ui';

const DirectoryContactMenu = ({ onEditClick, onDeleteClick }: any) => {
  return (
    <Menu>
      <Menu.Group>
        <Menu.Item onSelect={onEditClick}>Edit contact</Menu.Item>
      </Menu.Group>
      <Menu.Divider />
      <Menu.Group>
        <Menu.Item intent="danger" onSelect={onDeleteClick}>
          Delete contact
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
};

export default DirectoryContactMenu;
